import "./ConfigurationGroups.html";

import type { IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import ConfigurationGroupsComponentController from "./ConfigurationGroupsComponentController";

export class ConfigurationGroupsComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            site: "<",
        };
        this.controller = ConfigurationGroupsComponentController;
        this.templateUrl = "/App/Components/Site/Overview/ConfigurationGroups/ConfigurationGroups.html";
    }
}

module("mmManagePortal").component("mmOverviewConfigurationGroups", new ConfigurationGroupsComponent());
